import { Page } from '@/core/architecture'

import { ConsoleCollectionsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleCollections Page
 * Implemented as a practical sample.
 */
export const ConsoleCollections: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleCollectionsTemplate state={state} {...actions} />
}
